const internet = {
  its_seems_no_internet: "Il semble que vous ne soyez pas connecté à internet",
  internet_connection_restored: "Connexion internet restaurée",
};
export default internet;
